import React from 'react'

import classNames from 'classnames'

import { ViewType } from '@utils/global'

interface Props {
  setViewType: (type: ViewType) => void
  viewType: ViewType
  types: ViewType[]
  className?: string
}

const LayoutChanger: React.FC<Props> = ({
  setViewType,
  viewType,
  types,
  className,
}: Props): JSX.Element => {
  return (
    <div
      className={classNames('hidden flex-row justify-center items-center ml-6 md:flex', className)}>
      {types.map((type) => (
        <button
          type="button"
          key={`layout-${type}-selector`}
          className={classNames(
            'flex flex-col items-center px-1.5 py-1 rounded mr-1',
            viewType === type
              ? 'bg-gray-highlight mix-blend-multiply dark:bg-gray-highlight-dm dark:mix-blend-normal'
              : 'hover:bg-gray-highlight dark:hover:bg-gray-highlight-dm'
          )}
          onClick={() => {
            setViewType(type)
          }}>
          <i className={classNames('nf-icon text-h3 dark:text-gray', getIconForType(type))} />
        </button>
      ))}
    </div>
  )
}

export default LayoutChanger

function getIconForType(viewType: ViewType): string {
  switch (viewType) {
    case ViewType.GRID:
      return 'nf-columns'
    case ViewType.THUMBNAIL:
      return 'nf-grid'
    case ViewType.LIST:
      return 'nf-list'
    default:
      return ''
  }
}
